import { useState } from "react";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/contexts/CartContext";
import CartDrawer from "./CartDrawer";
import type { PaymentMethodId } from "@/lib/paymentMethods";

export interface CartFabProps {
  phone: string | null;
  storeName?: string;
  cartMessageTemplate?: string | null;
  acceptedPaymentMethods: PaymentMethodId[];
}

export default function CartFab({
  phone,
  storeName,
  cartMessageTemplate,
  acceptedPaymentMethods,
}: CartFabProps) {
  const { itemCount, isReady } = useCart();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!isReady || itemCount === 0) return null;

  return (
    <>
      <Button
        type="button"
        size="icon"
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full shadow-lg"
        onClick={() => setDrawerOpen(true)}
        aria-label="Abrir carrinho"
      >
        <ShoppingCart className="size-6" />
        <span className="absolute -top-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary-700 text-xs font-light text-white dark:bg-primary-300 dark:text-primary-950">
          {itemCount}
        </span>
      </Button>
      <CartDrawer
        phone={phone}
        storeName={storeName}
        cartMessageTemplate={cartMessageTemplate}
        acceptedPaymentMethods={acceptedPaymentMethods}
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
      />
    </>
  );
}
